import SaintVideoSection from "@/components/SaintVideoSection";
import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "SAINT for Treatment-Resistant Depression | Neuro Wellness TMS Centers of America",
  description:
    "SAINT accelerated TMS for treatment-resistant depression: FDA-cleared, five-day protocol with fMRI targeting. Learn if it may be right for you.",
  canonical: "/saint-for-treatment-resistant-depression",
  keywords:
    "SAINT treatment-resistant depression, SAINT TRD Florida, accelerated TMS TRD, SAINT TMS Coral Springs",
};

const relatedLinks = [
  { title: "SAINT TMS Overview", href: "/saint" },
  {
    title: "TMS for Treatment-Resistant Depression",
    href: "/tms-for-treatment-resistant-depression",
  },
  { title: "Verify a SAINT Provider", href: "/find-a-verified-saint-provider" },
  { title: "Am I a Candidate?", href: "/am-i-a-candidate" },
];

export default function SaintForTreatmentResistantDepression() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="SAINT for TRD"
      title="SAINT for Treatment-Resistant Depression"
      subtitle="SAINT is an FDA-cleared, accelerated TMS protocol designed specifically for adults whose depression hasn't responded to prior antidepressants."
      heroForm
      heroFormSource="saint-for-trd"
    >
      <DecisionSection heading="What SAINT is">
        <p>
          SAINT (Stanford Accelerated Intelligent Neuromodulation Therapy) is an
          FDA-cleared TMS protocol that compresses what is typically a six-week
          course of treatment into five consecutive days. It uses functional MRI
          to individually target the brain region most associated with your
          depression, then delivers ten stimulation sessions per day over five
          days.
        </p>
        <p>
          Neuro Wellness TMS Centers of America is the only Verified SAINT
          Provider in Florida on Magnus Medical's official list.
        </p>
      </DecisionSection>

      <DecisionSection heading="Who SAINT is for">
        <p>
          SAINT is FDA-cleared for major depressive disorder in adults who
          haven't improved adequately on prior antidepressants in the current
          episode. Whether it's appropriate for you is a clinical determination
          made during consultation.
        </p>
      </DecisionSection>

      <DecisionSection heading="How it's different from standard TMS">
        <DecisionList
          items={[
            "Speed — five days versus six to nine weeks",
            "Personalization — fMRI-derived individual targeting, not population averages",
            "Precision — neuronavigated coil placement rather than scalp measurement",
            "Schedule — ten sessions per day with 50-minute intervals",
          ]}
        />
      </DecisionSection>

      <SaintVideoSection variant="full" />

      <DecisionSection heading="Coverage">
        <p>
          SAINT bills under Category III CPT codes. Coverage is still developing
          across the industry and varies by plan. Our team verifies benefits
          before any financial commitment and handles authorization on your
          behalf.
        </p>
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link to="/contactus" className="text-accent hover:underline">
            schedule a consultation
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
